/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Rtl_LabelInputs */



/**
* | output |
* | --- |
* | "Right-To-Left" |
*
* @param {Merge_Event_Group_Rtl_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_rtl_label = /** @type {((inputs?: Merge_Event_Group_Rtl_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Rtl_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Droite a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Von rechts nach links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Da destra a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Справа налево")
	if (locale === "es") return /** @type {LocalizedString} */ ("De derecha a izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从右到左")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右から左へ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाएँ से बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Da direita para a esquerda")
	return /** @type {LocalizedString} */ ("Right-To-Left")
});